import log, { Logger } from 'loglevel';

import { getPrefixedLogger, onLogInit } from './LogHelper';

export let routerLog: Logger;
onLogInit(() => { routerLog = getPrefixedLogger('router', 'pink', log.levels.SILENT); });
